var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "26px",
    viewBox: "0 0 26 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6175BF2E-576E-47DD-B33B-051C3D5BBD9B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mapping-2",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-690.000000, -218.000000)",
    id: "pin-red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M703.000425,225.751174 C700.093755,225.751174 697.728485,228.137462 697.728485,231.070737 C697.728485,234.004013 700.093755,236.390301 703.000425,236.390301 C705.907426,236.390301 708.272697,234.004013 708.272697,231.070737 C708.272697,228.137462 705.907426,225.751174 703.000425,225.751174 M711.843545,221.106174 C709.580758,219.103478 706.439879,218 703,218 C699.560121,218 696.419242,219.103478 694.156455,221.106174 C691.437091,223.513478 690,227.172565 690,231.688609 C690,241.525217 701.396273,253.051478 701.881212,253.537087 C702.177061,253.833696 702.580061,254 703,254 C703.419939,254 703.822939,253.833696 704.118788,253.537087 C704.603727,253.051478 716,241.525217 716,231.688609 C716,227.172565 714.562909,223.513478 711.843545,221.106174"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.03c8dd2a6fa2ed8e23d3e864f601fa87.svg";
export { ForwardRef as ReactComponent };